import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'ui-custom-toaster',
  templateUrl: './ui-custom-toaster.component.html',
  styleUrls: ['./ui-custom-toaster.component.scss'],
  host: {
    '[style.--animation-easing]': 'params.easing',
    '[style.--animation-duration]': 'params.easeTime + "ms"',
    'animate.enter': 'toast-in',
  },
})
export class UiCustomToasterComponent extends Toast {
}
